function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function Svg04N(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 46.215,
    height: 26.368,
    viewBox: "0 0 46.215 26.368",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    "data-name": "04n"
  }, /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 184456"
  }, /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 14415",
    d: "M510.9 58.139a6.089 6.089 0 0 0-6.113-5.176 6.189 6.189 0 0 0-5.53 3.312 3.482 3.482 0 0 0-.324-.218c0 .056-2.426-.117-3.084 1.878a12.519 12.519 0 0 0-.358 2.773 8.168 8.168 0 0 1 1.306.783 6.005 6.005 0 0 1 2.84 4.667h10.342A4.152 4.152 0 0 0 514.2 62.1a4.112 4.112 0 0 0-3.3-3.961z",
    transform: "translate(-467.983 -45.511)",
    style: {
      fill: "#e06d6d"
    }
  }), /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 184455"
  }, /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 184454"
  }, /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 14416",
    d: "M530.264 57.855a4.028 4.028 0 0 1 3.729 2.645c.153.41.815.232.661-.182a4.735 4.735 0 0 0-4.39-3.148.343.343 0 0 0 0 .686z",
    transform: "translate(-492.982 -48.564)",
    style: {
      fill: "#fff"
    }
  })))), /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 184459"
  }, /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 14417",
    d: "M422.237 65.355a4.566 4.566 0 0 0-4.509-3.532 4.693 4.693 0 0 0-2.871.971 8.171 8.171 0 0 0-7.3-4.372 8.038 8.038 0 0 0-8.07 6.834 5.428 5.428 0 0 0-4.351 5.225 5.482 5.482 0 0 0 5.567 5.359h19.917a5.482 5.482 0 0 0 5.567-5.359 5.409 5.409 0 0 0-3.95-5.126z",
    transform: "translate(-395.135 -49.474)",
    style: {
      fill: "#d32f2f"
    }
  }), /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 184457"
  }, /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 14418",
    d: "M419.342 65.348a6.454 6.454 0 0 1 5.228-2.791.387.387 0 0 0 0-.773 7.271 7.271 0 0 0-5.9 3.173c-.286.408.384.8.667.39z",
    transform: "translate(-412.171 -51.915)",
    style: {
      fill: "#fff"
    }
  })), /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 184458"
  }, /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 14419",
    d: "M399.679 92.266a4.2 4.2 0 0 1 1.97-3.5c.418-.267.031-.937-.39-.667a5 5 0 0 0-2.353 4.167.387.387 0 0 0 .773 0z",
    transform: "translate(-397.871 -70.971)",
    style: {
      fill: "#fff"
    }
  })), /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 184622"
  }, /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 14526",
    d: "M3.565 10.418A5.31 5.31 0 0 1 0 9.038h.343A5.67 5.67 0 0 0 4.9 0a5.294 5.294 0 0 1-1.335 10.416z",
    transform: "rotate(105.01 13.174 12.417)",
    style: {
      fill: "#283593"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 14527",
    d: "M3.42.713a.151.151 0 0 0 .1-.076L3.876 0l.349.637a.151.151 0 0 0 .1.076l.718.137-.5.53a.145.145 0 0 0-.04.123l.09.719-.657-.307a.145.145 0 0 0-.129 0l-.659.307.09-.719A.149.149 0 0 0 3.2 1.38L2.7.85zM.3 3.672l.06-.466a.149.149 0 0 0-.04-.123L0 2.742l.46-.084a.157.157 0 0 0 .1-.076l.225-.4.227.4a.149.149 0 0 0 .1.076l.46.086-.325.339a.155.155 0 0 0-.04.123l.058.466-.424-.2a.155.155 0 0 0-.129 0zm3.9 1.247a.151.151 0 0 0-.038.123l.058.464L3.8 5.3a.149.149 0 0 0-.064-.014.143.143 0 0 0-.064.014l-.424.2.058-.464a.153.153 0 0 0-.04-.123l-.321-.341.46-.088a.153.153 0 0 0 .1-.074L3.738 4l.225.412a.153.153 0 0 0 .1.074l.46.088z",
    transform: "rotate(105.01 13.452 11.452)",
    style: {
      fill: "#283593"
    }
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(Svg04N);
export default __webpack_public_path__ + "static/media/04N.ce091e3cd70ad188299c143e325f9cd6.svg";
export { ForwardRef as ReactComponent };